import ninjaApi from 'store/redux/apis/ninja.api';

export const pnlBalanceApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['PnLBalance'],
  endpoints: (build) => ({
    balancesList: build.query({
      query: (body) => ({
        url: '/pnl-balances/load',
        method: 'POST',
        body,
      }),
      providesTags: ['PnLBalance'],
    }),
  }),
});

export const { useBalancesListQuery } = pnlBalanceApi;
